module.exports = __webpack_public_path__ + "img/numberboxnone.09278a41.png";